<template>
  <div class="video-modal">
    <button
      @click.stop="$emit('close-video-player')"
      class="video-modal__close-btn"
    >
      <XCircleIcon size="25" class="video-modal__close-btn__icon" />
    </button>
    <div v-show="!isComponentLoading" class="video-modal__container">
      <div class="video-modal__container__header">
        <img
          class="video-modal__container__header__instructor-avatar"
          :src="instructor.profile_img_url"
          alt="INSTRUCTOR_IMG"
        />
        <div class="video-modal__container__header__info">
          <div class="video-modal__container__header__info__video-name">
            {{ video.name }}
          </div>
          <div class="video-modal__container__header__info__instructor-name">
            {{ instructor.name }}
          </div>
        </div>
      </div>
      <MediaDelegate
        class="video-modal__container__media"
        v-if="parentContent"
        v-bind="{
          parentType: parentContent.content_type,
          content: { ...video, type: 'video', id: video.objectID },
          userCompletionStatus: 'unfinished', // Algolia doesn't have status of a video
          manualParent: parentContent,
        }"
        @is-loading="setIsLoading"
      />
      <ParentContentTags
        class="video-modal__container__parent-content-tags"
        contentType="video"
        :contents="parents"
      />
    </div>
    <div v-show="isComponentLoading" class="video-modal__spinner-wrapper">
      <ActionLoader loaderClass="video-modal__spinner" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import MediaDelegate from '@/components/media/MediaDelegate.vue'
import { XCircleIcon } from 'vue-feather-icons'
import ParentContentTags from '@/components/search/content-rows/ParentContentTags.vue'

export default {
  name: 'VideoModal',
  components: {
    XCircleIcon,
    ActionLoader,
    MediaDelegate,
    ParentContentTags,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    parents: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isComponentLoading: state => state.app.isComponentLoading,
    }),
    parentContent() {
      return this.parents[0]
    },
    instructor() {
      const { instructors } = this.parentContent
      return instructors.length && instructors[0]
    },
  },
  methods: {
    setIsLoading(state) {
      this.$store.dispatch('app/setIsComponentLoading', state)
    },
  },
  destroyed() {
    this.$store.dispatch('content/resetContentState')
    document.querySelector('body').style.overflowY = 'visible'
  },
}
</script>

<style lang="scss" scoped>
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: var(--black-90);
  transition: opacity 0.3s ease;
  overflow: auto;
  &__container {
    display: flex;
    flex-flow: column;
    gap: 10px;
    position: relative;
    margin: 25px auto;
    color: var(--white);
    @include tablet {
      max-width: 60vw;
      min-height: 60vh;
    }

    &__header {
      display: flex;
      align-items: center;
      gap: 10px;
      &__instructor-avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      &__info {
        &__video-name {
          font-family: var(--font-bold);
          font-style: normal;
          font-weight: 500;
          font-size: rem(16px);
          line-height: rem(23px);
        }
        &__instructor-name {
          margin-top: 5px;
          font-family: var(--font-book);
          font-style: normal;
          font-weight: 450;
          font-size: rem(12px);
          line-height: rem(14px);
        }
      }
    }
    &__media {
      width: 100%;
    }
  }
  &__close-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--white);
    &:hover {
      color: var(--orange);
    }
  }
  &__spinner-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
